
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
import VChart from 'vue-echarts'
import { defineComponent, PropType } from 'vue'
import type { ECBasicOption } from 'echarts/types/dist/shared'

export default defineComponent({
  components: { VChart },
  props: {
    options: { type: Object as PropType<ECBasicOption> }
  },
  setup() {
    use([
      CanvasRenderer,
      PieChart,
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      LineChart,
      GridComponent,
      DataZoomComponent
    ])
  }
})

